import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
// SYSTEM1
import Loader from "@/components/widgets/loader.vue";
import Layout from "@/router/layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import simplebar from "simplebar-vue";
import Switches from "vue-switches";
import EcGrid from "@/components/widgets/EcGrid.vue";
import DeleteComponent from "@/components/deleteComponent.vue";
import { interpret } from "xstate";
import { PMOTagModel } from "@/store/models/tag/PMOTag";
import { TagModule } from "@/store/modules/tag.module";
import TagsMachine from "./machines/tagsMachine";
import { Chrome } from "vue-color";
Component.registerHooks(["metaInfo", "beforeRouteEnter"]);
let Tags = /** @class */ (() => {
    let Tags = class Tags extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.title = "Tags";
            this.searchKey = "";
            this.showFeaturedTags = false;
            this.tag = new PMOTagModel();
            this.isPageDirty = false;
            this.teams = [];
            this.defaultColor = "#000000";
            this.items = [
                { text: "Home", to: "/dashBoard" },
                { text: "PMO", href: "#" },
                { text: "Tags", active: true },
            ];
            this.isGridLoading = false;
            this.initialPage = 1;
            this.initialPageSize = 10;
            this.initialSortBy = {
                field: "name",
                type: "asc",
            };
            this.columns = [
                {
                    field: "name",
                    label: "Tag Name",
                    tdClass: "tag-name",
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        placeholder: "Tag Name",
                    },
                },
                {
                    field: "description",
                    label: "Description",
                    tdClass: "tag-description",
                    sortable: false,
                    filterOptions: {
                        enabled: false,
                        placeholder: "Description",
                    },
                },
                {
                    field: "color",
                    label: "Tag Color",
                    thClass: "text-center",
                    tdClass: "tag-color text-center",
                    sortable: false,
                    filterOptions: {
                        enabled: false,
                        placeholder: "Color",
                    },
                },
                {
                    field: "teamName",
                    label: "Team",
                    tdClass: "tag-team",
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        placeholder: "Team",
                    },
                },
                {
                    field: "actions",
                    label: "Actions",
                    thClass: "tag-action text-center",
                    tdClass: "tag-action",
                    sortable: false,
                },
            ];
            this.serverParams = {
                columnFilters: {},
                sort: {
                    field: "name",
                    type: "asc",
                },
                page: 1,
                pageSize: 10,
            };
            this.totalCount = 0;
            this.machine = TagsMachine;
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
        }
        // METHODS
        resetTag() {
            this.tag.id = null;
            this.tag.name = null;
            this.tag.description = null;
            this.tag.color = this.defaultColor;
            this.tag.teamId = null;
        }
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        }
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
            this.loadItems();
        }
        onPerPageChange(params) {
            if (!this.isPageDirty) {
                this.initialPage = 1;
            }
            this.updateParams({
                pageSize: params.currentPerPage,
                page: this.initialPage,
            });
            this.loadItems();
        }
        onSortChange(params) {
            if (!this.isPageDirty) {
                this.initialPage = 1;
            }
            this.updateParams({ sort: params[0], page: this.initialPage });
            this.loadItems();
        }
        onColumnFilter(params) {
            if (!this.isPageDirty) {
                this.initialPage = 1;
            }
            this.updateParams({
                columnFilters: params.columnFilters,
                page: this.initialPage,
            });
            this.loadItems();
        }
        loadItems() {
            this.isGridLoading = true;
            let filters = [];
            Object.entries(this.serverParams.columnFilters).forEach(([key, value]) => {
                filters.push({ name: key, value: value });
            });
            const searchData = {
                page: this.serverParams.page,
                pageSize: this.serverParams.pageSize,
                sort: this.serverParams.sort,
                columnFilters: filters,
            };
            TagModule.AssignSearchParams(searchData);
            this.machineService.send({
                type: "GETTING_TAGS",
                searchData: searchData,
            });
        }
        clearFilter() {
            this.serverParams.columnFilters = {};
            const ecgrid = this.$refs.ecgrid;
            ecgrid.$refs.grid.$refs["table-header-primary"].$refs["filter-row"].columnFilters = {};
            this.loadItems();
        }
        showTagDeleteModal(tagId) {
            const isPageChanged = this.rows.length === 1 && this.serverParams.page !== 1;
            this.tagId = tagId;
            this.machineService.send({ type: "DELETE_TAG", ispageChanged: isPageChanged });
        }
        deleteTag() {
            this.machineService.send({ type: "DELETING_TAG", tagId: this.tagId });
            this.loadItems();
        }
        cancelTag() {
            this.machineService.send({ type: "CLOSE_MODAL" });
        }
        showAddTag() {
            this.isEditMode = false;
            this.resetTag();
            this.machineService.send({ type: "ADD_TAG" });
        }
        showEditTag(tag) {
            if (tag) {
                this.isEditMode = true;
                this.tag.id = tag.id;
                this.tag.name = tag.name;
                this.tag.description = tag.description;
                this.tag.color = tag.color;
                this.tag.teamId = tag.teamId;
                this.machineService.send({ type: "EDIT_TAG" });
            }
        }
        async saveTag() {
            const isValid = await this.validate("createTagObserver");
            if (!isValid) {
                //toaster.ShowError("Please fill all the required fields.");
                return;
            }
            if (this.isEditMode) {
                this.machineService.send({
                    type: "EDITING_TAG",
                    tag: this.tag,
                });
            }
            else {
                this.machineService.send({
                    type: "ADDING_TAG",
                    tag: this.tag,
                });
            }
        }
        closeModal() {
            this.machineService.send({ type: "CLOSE_MODAL" });
        }
        onRowClick(params) {
            this.showEditTag(params.row);
        }
        async beforeRouteEnter(to, from, next) {
            if (from.name !== "TagOverview") {
                TagModule.ClearSearchParams();
            }
            next();
        }
        async initialize() {
            const value = TagModule.searchParams;
            if (value != null) {
                this.isPageDirty = true;
                this.initialPage = value.page;
                this.serverParams.pageSize = value.pageSize;
                value.columnFilters = value.columnFilters;
                if (value.columnFilters.length > 0) {
                    value.columnFilters.forEach((item) => {
                        this.serverParams.columnFilters[item.name] = item.value;
                    });
                }
                this.initialSortBy = value.sort;
            }
        }
        assignColumnFilters() {
            const ecgrid = this.$refs.ecgrid;
            const gridColumns = ecgrid.$refs.grid.$refs["table-header-primary"].$refs["filter-row"].columnFilters;
            if (this.gridParams && this.gridParams.columnFilters.length > 0) {
                this.gridParams.columnFilters.forEach((item) => {
                    this.isPageDirty = true;
                    gridColumns[item.name] = item.value;
                });
            }
        }
        // Computed properties
        get rows() {
            return TagModule.tagGridViewEntries;
        }
        get gridParams() {
            return TagModule.searchParams;
        }
        get totalTags() {
            return TagModule.totalTags;
        }
        get tagGridViewEntries() {
            return TagModule.tagGridViewEntries;
        }
        get isAnyFilterApplied() {
            return this.columnFilters.length !== 0 && this.columnFilters.some((x) => x.value);
        }
        get columnFilters() {
            const filters = [];
            Object.entries(this.serverParams.columnFilters).forEach(([key, value]) => {
                filters.push({ name: key, value: value });
            });
            return filters;
        }
        get isAccessDenied() {
            return this.state.hasTag("appUserIsNotTeamLead");
        }
        created() {
            this.initialize();
            this.machineService.start();
            this.machineService.onTransition((state) => {
                const previousState = this.state;
                this.state = state;
                if (previousState.matches("gettingTeams") && this.state.matches("gettingTags")) {
                    this.teams = TagModule.teams;
                    this.assignColumnFilters();
                }
                if (this.state.matches("addTag") || this.state.matches("editTag")) {
                    this.$bvModal.show("tag-operations");
                }
                if (this.state.matches("loadedTags")) {
                    this.$bvModal.hide("tag-operations");
                    this.totalCount = this.totalTags;
                    this.isGridLoading = false;
                    this.isPageDirty = false;
                }
                if (this.state.matches("gettingTags") && previousState.matches("deletingTag")) {
                    if (this.state.context.ispageChanged) {
                        this.serverParams.page = this.serverParams.page - 1;
                    }
                }
            });
        }
        destroyed() {
            this.machineService.stop();
        }
    };
    Tags = __decorate([
        Component({
            name: "Tags",
            components: {
                Loader,
                Layout,
                PageHeader,
                simplebar,
                EcGrid,
                DeleteComponent,
                Switches,
                "chrome-picker": Chrome,
            },
        })
    ], Tags);
    return Tags;
})();
export default Tags;
